export default "/images/getstartedbg.png?ef116e6089aefa355a236d02cb456bb2";